// define nuxt vue-i18n config options
import vuei18nConfig from '@/config/vuei18nConfig'
// @ts-ignore --- defineI18nConfig is auto-imported
export default defineI18nConfig(nuxt => ({
  ...vuei18nConfig
}))